import Carousel from "@/src/components/common/carousel";
import Image from "next/image";
import Iconify from "@/src/components/iconify/Iconify";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import IconCode from "@/src/lib/iconCode";

const Testimonials = () => {
    const isMobile = useBreakpoint("sm");

    return (
        <div className="py-8 md:py-16 bg-[#ffeaea] flex justify-center items-center">
            <div className="max-w-4xl w-full testimonial mx-auto px-4">
                <h2 className="md:text-2xl text-xl font-bold text-black md:mb-8 mb-4 text-center">
                    Testimonials
                </h2>
                <Carousel
                    settings={{
                        arrows: false,
                        autoplay: true,
                        infinite: true,
                        speed: 700,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                },
                            },
                        ],
                    }}
                >
                    {TestimonialCard?.length > 0 &&
                        TestimonialCard?.map((item, index) => (
                            <div key={index} className="flex justify-center">
                                <div className="flex flex-col bg-white shadow-md md:p-20 p-14 relative pb-5 h-full max-w-3xl w-full">
                                    <Iconify
                                        icon={IconCode.quotesLeft}
                                        width={isMobile ? "50px" : "100px"}
                                        className="text-4xl text-gray-100 absolute top-0 left-10"
                                    />

                                    <Iconify
                                        icon={IconCode.quotesLeft}
                                        width={isMobile ? "50px" : "100px"}
                                        className="text-4xl text-gray-100 absolute bottom-0 right-10 rotate-180"
                                    />

                                    <p className="text-black text-center text-xl font-bold mb-2">
                                        {item?.heading}
                                    </p>
                                    <p className="text-black text-center text-base font-normal">
                                        {item?.description}
                                    </p>

                                    <p className="text-black text-center text-lg font-bold md:mt-10 mt-5">
                                        {item?.name}
                                    </p>
                                    <p className="text-black text-center text-base font-bold">
                                        {item?.place}
                                    </p>
                                    <div className="md:w-28 md:h-28 w-24 h-24 mt-4 mx-auto">
                                        <Image
                                            src={item?.image}
                                            alt={item?.name}
                                            width={0}
                                            height={0}
                                            sizes="(max-width: 768px) 100vw, 33vw"
                                            className="rounded-full object-cover shadow-lg w-full h-full"
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                </Carousel>
            </div>
        </div>
    );
};

const TestimonialCard = [
    {
        name: "Rahul Choubey",
        place: "Delhi",
        heading: "Reliable reports, no more waiting for test.",
        image: "/images/rahul.jpg",
        description:
            "My experience was good in HOD, it has reasonable price for test and supportive staff, reliable reports, no more waiting for test and I got my report on the same day.",
    },
    {
        name: "SK Sinha",
        place: "Noida",
        heading: "Team of HOD is extremely cooperative.",
        image: "/images/sinha.jpg",
        description:
            "The whole team of HOD is extremely cooperative, prompt and willing to help. We have always had a pleasant experience here. Many thanks for your cooperation. Keep it up. Cheers!!",
    },
    {
        name: "Aman Kumar",
        place: "Delhi",
        heading: "Well organised and clean center..",
        image: "/images/aman.jpg",
        description:
            "Very kind, understanding, supportive n helpful staff. Very good services at a reasonable price, Well organized center Thank you.",
    },
];

export default Testimonials;
